module.exports = __webpack_public_path__ + "static/media/envelop.3d5386f8.png";